import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@material-ui/core";
import React from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import CanvasSignature from "../../common/CanvasSignature/CanvasSignature";

function SignaturePopup({openSignDialog, uploadFileToDb, visitorData, closeSignaturePopup}) {
  return (
    <Dialog
        open={openSignDialog}
        aria-labelledby={"responsive-dialog-title"}
        maxWidth={"lg"}
    >
        <AppBar
        style={{ position: "relative", backgroundColor: "#064473" }}
        >
        <Toolbar>
            <Typography
            variant={"h6"}
            style={{
                marginLeft: "10px",
                flex: "1",
                marginRight: "18px"
            }}
            >
            {"Please add your signature below.\r"}
            </Typography>
            <IconButton
            title={"Close"}
            edge={"start"}
            color={"inherit"}
            onClick={closeSignaturePopup}
            aria-label={"close"}
            >
            <IoMdCloseCircleOutline />
            </IconButton>
        </Toolbar>
        </AppBar>
        <div style={{ border: "1px solid" }}>
        {" "}
            <CanvasSignature
                requestedFor={visitorData?.RequestedFor}
                uploadFileToDb={uploadFileToDb}
            />
        </div>
    </Dialog>
    );
}

export default SignaturePopup;
